/* eslint-disable max-lines-per-function */
import { EventBus, Events, store } from "jiffy-store";
import { on as onEvent } from "common/utils/ui/event";
import collectFormItemsQty, { formatQuantity } from "common/utils/form/collect-form-items-qty";
import { addToCartAnalytics } from "components/jiffy/product-details-quantity-form/analytics";
import "./product-grid.scss";

const SELECTORS = {
  GRID_SIZE: ".js-product-grid .js-grid-size",
  INPUT: "input",
  INPUT_CONTAINER: ".js-input-container",
  LABEL: ".js-stock",
  PRICE: ".js-price",
  OUT: ".js-out-stock"
};

// TODO: Very heavy function
const setProductGridInventory = (variantCounts, highlightChanges = false) => {
  const sizes = Array.from(document.querySelectorAll(SELECTORS.GRID_SIZE));
  sizes.forEach(element => {
    const input = element.querySelector(SELECTORS.INPUT);
    const label = element.querySelector(SELECTORS.LABEL);
    const price = element.querySelector(SELECTORS.PRICE);
    const outOfStock = element.querySelector(SELECTORS.OUT);
    if (!input) {
      return;
    }

    const id = input.dataset.variantId;
    const { colorVariantIds, productOnSale, soldOutClass } = input.dataset;
    const hasStockForOtherVariants = JSON.parse(colorVariantIds)
      .map(elem => variantCounts[elem])
      .some(elem => elem !== 0);
    const colorSoldOut = !hasStockForOtherVariants && productOnSale === "true";

    let quantity = variantCounts[id];
    if (highlightChanges && label.innerHTML !== formatQuantity(quantity)) {
      label.classList.add(label.dataset.highlightClass);
    }
    if (quantity > 0) {
      quantity = formatQuantity(quantity);
      label.innerHTML = quantity;
      input.classList.remove("hide");
      if (price) price.classList.remove("invisible");
      label.classList.remove("product-grid__stock--out");
      outOfStock.classList.add("hide");
    } else if (colorSoldOut) {
      label.classList.add("hide");
      if (price) price.classList.add("invisible");
      const inputContainer = element.querySelector(SELECTORS.INPUT_CONTAINER);
      inputContainer.innerHTML = "Sold Out";
      inputContainer.classList.add(soldOutClass);
    } else {
      input.classList.add("hide");
      if (price) price.classList.add("invisible");
      label.innerHTML = "Out";
      label.classList.add("product-grid__stock--out");
      outOfStock.classList.remove("hide");
    }
  });
  if (!highlightChanges) return;

  const stockLabels = document.querySelectorAll(SELECTORS.LABEL);
  setTimeout(() => {
    stockLabels.forEach(label => label.classList.remove(label.dataset.highlightClass));
  }, 1000);
};

const onSubmit = (event, form, modal) => {
  event.preventDefault();
  const formItemsQty = collectFormItemsQty($(form));

  EventBus.publish(Events.ADD_TO_CART, { items: formItemsQty, eventAction: "Bulk" });

  const foundFilledQty = Array.from(form.querySelectorAll("[name^='variants']")).find(
    el => el.value !== ""
  );

  if (foundFilledQty) {
    const eventId = form.querySelector("#bulk-form-event-id").value;
    addToCartAnalytics({ itemsQty: formItemsQty, eventId, isBulk: true });
    store.cart.change({ items: formItemsQty });

    form.querySelectorAll(".product-grid__cart-button").forEach(button => {
      // eslint-disable-next-line
      button.disabled = true;
    });

    setTimeout(() => {
      form.submit();
    }, 350);
  } else {
    event.preventDefault();
    $(modal).modal("show");
  }
};

const cacheDesktopGridDom = () => {
  const desktopGridForm = document.querySelector("#product-grid-form");
  const productGridForm = [];

  desktopGridForm.querySelectorAll("input[name^='variants[']").forEach(input => {
    const variantId = parseInt(input.name.match(/variants\[(\d+)\]\[quantity\]/)[1], 10);
    productGridForm[variantId] = {
      input,
      priceElement: input.closest(".product-grid__size").querySelector(".product-grid__price")
    };
  });

  store.pdp.change({ productGridForm });
};

const initListeners = () => {
  cacheDesktopGridDom();
  setProductGridInventory(window.inventory);

  const form = document.querySelector(".product-grid__form");
  const modal = document.querySelector(".grid-validation-modal");

  form.addEventListener("submit", event => onSubmit(event, form, modal));

  $(SELECTORS.INPUT, SELECTORS.GRID_SIZE).on("input", event => {
    const { variantId } = event.currentTarget.dataset;
    // PIP-3358: on the canonical-URL surface the selected color lives in the
    // #active-color-name DOM input, not ?ac= (the hash rewrite strips it).
    // Prefer the in-page value so PRODUCT_INPUT_CHANGED consumers (delivery
    // estimates, updateSellingPrices) resolve the selected color, not null.
    const colorName =
      document.getElementById("active-color-name")?.value ||
      new URLSearchParams(window.location.search).get("ac");

    const totalValue = Array.from(form.querySelectorAll(".js-grid-input")).reduce((acc, elem) => {
      const inputValue = parseInt(elem.value, 10);
      const parsedValue = !Number.isNaN(inputValue) ? inputValue : 0;
      return acc + parsedValue;
    }, 0);

    EventBus.publish(Events.PRODUCT_INPUT_CHANGED, form, totalValue, colorName, variantId);
  });
};

const initQtyFieldsValidator = () => {
  const eventCallback = ({ target }) => {
    // allows only digits without leading 0
    // eslint-disable-next-line no-param-reassign
    target.value = target.value.replace(/[^0-9]/g, "").replace(/^0/, "");
  };

  onEvent("input", ".js-grid-input", eventCallback, true);
};

const initGrid = () => {
  const details = document.querySelector(".js-product-details");

  if (details?.dataset.productId) {
    setProductGridInventory(window.inventory);
    store.pdp.change({ isSettingPDPBadges: true, isSettingGridInventory: true });
  }

  const $form = document.querySelector(".product-grid__form");
  initListeners($form);
  initQtyFieldsValidator();
};

export default () => {
  const $grid = document.querySelector(".js-product-grid");
  let loaded = false;

  store.pdp.changed((_, { data }) => {
    if (!data.productGridLoaded || loaded || !window.inventory) return;
    loaded = true;
    initGrid();
  });

  if ($grid) {
    store.pdp.change({
      productGridLoaded: true,
      isSettingPDPBadges: true,
      isSettingGridInventory: true
    });
  }
};
